import { render, staticRenderFns } from "./launchEvent.vue?vue&type=template&id=168cf584&scoped=true&"
import script from "./launchEvent.vue?vue&type=script&lang=js&"
export * from "./launchEvent.vue?vue&type=script&lang=js&"
import style0 from "./launchEvent.vue?vue&type=style&index=0&id=168cf584&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168cf584",
  null
  
)

export default component.exports